<template>
  <div class="role-purpose-tab">
    <ExBreadcrumbs
      class="mb-5 mb-md-6"
      :breadcrumbsList="breadcrumbsList"
      @onClickBreadcrumb="handleBreadcrumbClick"
    />
    <div class="business-purpose-title">
      Business Purpose of the Organization
    </div>
    <div class="iq-assist-banner">
      <div class="iq-assist-banner-icon-img-wrapper">
        <img :src="require('@components/assets/info-circle.svg')" alt="" class="logo-img">
      </div>
      <div class="iq-assist-banner-content">
        <div class="iq-assist-banner-title">Provide better Assistance</div>
        <div class="iq-assist-banner-description">
          IQ uses business purpose as context to provide better answers
        </div>
      </div>
    </div>
    <PurposeViewEdit
      class="mt-6"
      :value="purpose"
      placeholder="Enter purpose"
      :maxLength="3000"
      :isSaving="false"
      :showTiptapEditor="true"
      @save="handleSave"
      @discard="handleDiscard"
      @close="handleClose"
      @add-purpose="() => emit('add-purpose')"
      @edit="() => emit('edit')"
      @improve="(val) => emit('improve', val)"
      @suggest="() => emit('suggest')"
      hideAIButtons="true"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import ExBreadcrumbs from '@components/breadcrumbs/ExBreadcrumbs.vue';
import PurposeViewEdit from '@components/PurposeViewEdit/PurposeViewEdit.vue';
import Icon from '@components/icons/Icon.vue';

const props = defineProps({
  purpose: {
    type: String,
    default: ''
  },
});
const emit = defineEmits(['update:purpose', 'save', 'discard', 'add-purpose', 'edit', 'improve', 'suggest']);

const breadcrumbsList = ref([
  { text: 'Configuration', disabled: false },
  { text: 'IQ Assistant', disabled: true },
]);

function handleSave(newValue) {
  emit('update:purpose', newValue);
  emit('save', newValue);
  props.purpose = newValue;
}

function handleBreadcrumbClick(breadcrumb) {
  if (breadcrumb.text === 'Configuration') {
    emit('discard');
  }
}

function handleDiscard() {
  // Discard changes but stay in edit mode (don't navigate away)
  // Do nothing - just let PurposeViewEdit handle the state change
}

function handleClose() {
  // Close edit mode without navigating away
  // Do nothing - just let PurposeViewEdit handle the state change
}
</script>

<style scoped>
.business-purpose-title {
  font-family: Inter;
  font-weight: 700;
  font-style: Bold;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
  margin-left: 2px;
}
.role-purpose-tab {
  width: 100%;
}
.iq-assist-banner {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  border-radius: 8px;
  border: 1px solid #D0D5DD;
  padding: 16px;
  margin-top: 24px;
  margin-bottom: 24px;
  box-shadow: 0px 1px 2px 0px #1018280D;
}
.iq-assist-banner-icon-img-wrapper {
  display: flex;
  padding: 10px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius:  8px;
  border: 1px solid #EAECF0;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}
.iq-assist-banner-icon-img {
  width: 100%;
}
.iq-assist-banner-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.iq-assist-banner-title {
  font-family: Inter;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #344054;
}
.iq-assist-banner-description {
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #475467;
}
</style>